<ul class="icon-sidebar">
  <li class="icon" title="Home">
    <a href="" id="home-link" [routerLink]="['/home']" routerLinkActive="active">
      <span class="sidebartext homeIcon" ></span>
    </a>
  </li>
  <li [ngClass]="{'disableDiv': appDisable}" *ngIf="userLoggedIn&&!appDisable" class="icon" title="Admin">
    <a href="" id="home-link" [routerLink]="['/admin']" routerLinkActive="active">
      <span class="sidebartext loginIcon"></span>
    </a>
  </li>
  <li class="icon" *ngIf="userLoggedIn" title="Import">
    <a href="" id="home-link" [routerLink]="['/import']" routerLinkActive="active">
      <span class="sidebartext Exportbtn"></span>
    </a>
  </li>
  <li class="icon" *ngIf="userLoggedIn" title="Data Management">
    <a href="" id="home-link" [routerLink]="['/datamanagement']" routerLinkActive="active">
      <span class="sidebartext DataProcessing"></span>
    </a>
  </li>
  <li class="icon" *ngIf="userLoggedIn" title="Content Management">
    <a href="" id="home-link" [routerLink]="['/contentManagement']" routerLinkActive="active">
      <span class="sidebartext ContentManagement"></span>
    </a>
  </li>
  <li class="icon" *ngIf="userLoggedIn" title="Reports">
    <a href="" id="home-link" [routerLink]="['/reporting']" routerLinkActive="active">
      <span class="sidebartext Reporting"></span>
    </a>
  </li>
</ul>